/*
 * Copyright (c) 2026 SimplyBook.me Ltd. All rights reserved.
 * Licensed under the Apache License, Version 2.0.
 */

import { useMutation, useQueryClient } from "@tanstack/react-query";
import { fetcher } from "./fetcher";
import { mutationKeys, queryKeys } from "./queryKeys";

export const useClientPersonalData = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationKey: mutationKeys.clientPersonalData,
    mutationFn: ({ code, email }) => fetcher({ method: "GET", url: "/public/gdpr/info", params: { code, email } }),
    onSuccess: (data) => {
      queryClient.setQueryData(queryKeys.client.personalDataStored, data);
    },
  });
};
